import styled from "styled-components";

import Text from 'components/Text';

export const InputThemer = styled.div`
  position: relative;
  overflow-x: scroll;

  input {
    height: 28px;
    padding: 0;
    padding-left: 3px;
    font-size: 12px;
    color: #364863;

    &:disabled,
    &.disabled {
      background: transparent;
      cursor: not-allowed;
    }
  }

  .table-scroll {
    display: table;

    .overflow-x {
      overflow-x: hidden;
    }

    .overflow-y {
      overflow-y: hidden;
    }
  }
`;

export const ContainerInfoTable = styled.div`
    padding: 0.8rem 0;
    height: 65px;
`;

export const OneLineText = styled(Text)`
    text-overflow: ellipsis;
    white-space: nowrap;
`;